<template>
  <Plain title="Almost done...">
    <div slot="page_body">
      <div class='headline'>
        We've sent an email to joe.doe@gmail.com. Open it up to activate your account.
      </div>
    </div>
  </Plain>
</template>
<script>
import Plain from './plain'

export default {
  name: 'PendingRegistration',
  components: {
    Plain
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PendingRegistration.vue